// ローカルストレージのポイント取得
function getCurrentPoint(){
  let customerId = document.getElementById('customerId').value;
  let currentPoint = getLocalStorage("sanyo_app_current_point_" + customerId);
  if (currentPoint) {
    // 保有ポイント表示
    let holdPoint = document.getElementById("cartPoints__info__header__pointCount__value");
    if (holdPoint) {
      holdPoint.innerHTML = currentPoint;
    } else {
      console.log('getCurrentPoint : cartPoints__info__header__pointCount__value is null');
    }
  }
  return currentPoint;
}

/** ポイント残高取得 */
function getPointBalance() {
  fetch('https://' + STORE_DOMAIN + APP_PROXY_PATH + '/point', {
    method: 'GET'
  }).then((response) => {
    if (response.status != 200) {
      console.log(response);
      throw new Error('status error');
    }
    return response.json();
  }).then((data) => {
    if (!data.error_flg) {
      // 保有ポイント表示
      let holdPoint = document.getElementById("cartPoints__info__header__pointCount__value");
      if (holdPoint) {
        holdPoint.innerHTML = data.point;
      } else {
        console.log('getPointBalance : cartPoints__info__header__pointCount__value is null');
      }

      // ローカルストレージ登録
      let customerId = document.getElementById('customerId').value;
      addLocalStorage('sanyo_app_current_point_' + customerId, data.point);
    } else {
      throw new Error('status error');
    }
  }).catch((err) => {
    console.log(err);
    dispMessage('システムエラーが発生しました。\nページを再読み込みしてください。解決しない場合には、三陽商会ECカスタマーサポートへお問い合わせください。');
    throw new Error(err);
  });
}

/** ポイント利用中の判定 */
async function isPointUsing(url){
  var isUsing = false;
  let customerId = document.getElementById('customerId').value;
  
  // 小計をローカルストレージに保持
  let data = await getCartToken(url);
  addLocalStorage('sanyo_app_subtotal_price_' + customerId, (data.items_subtotal_price / 100));
  
  let cartToken = getLocalStorage('sanyo_app_cart_token_' + customerId);
  if (cartToken) {
    let cartTokenJs = data.token
    if (cartToken == cartTokenJs) {
      isUsing = true;
      let pointUseDate = getLocalStorage('sanyo_app_point_use_date_' + customerId);

      let period = 1000 * 60 * 60; // 1時間
      let diff = parseFloat(pointUseDate) + period;
      let now = Date.now();
      if (diff < now) {
        isUsing = false;
        delLocalStorage('sanyo_app_cart_token_' + customerId);
        delLocalStorage('sanyo_app_point_use_date_' + customerId);
        delLocalStorage("sanyo_app_gift_card_code_" + customerId);
        delLocalStorage("sanyo_app_use_point_" + customerId);
      }
    } else {
      delLocalStorage('sanyo_app_cart_token_' + customerId);
      delLocalStorage('sanyo_app_point_use_date_' + customerId);
      delLocalStorage("sanyo_app_gift_card_code_" + customerId);
      delLocalStorage("sanyo_app_use_point_" + customerId);
    }
  }
  return isUsing;
}

/** Shopify API カート情報取得 */
function getCartToken(url){
  return fetch(url)
  .then((response) => {
    if (response.status != 200) {
      console.log(response);
      throw new Error('status error');
    }
    return response.json();
  }).then((data) => {
    return data;
  }).catch((err) => {
    console.log(err);
    dispMessage('システムエラーが発生しました。\nページを再読み込みしてください。解決しない場合には、三陽商会ECカスタマーサポートへお問い合わせください。');
    throw new Error(err);
  });
}

/** 入力チェック */
function checkValidation() {
  let disp = document.getElementById("err-disp");
  let usePointObj = document.getElementById("use-point");
  let errBackColor = "#ffb6c1";
  
  let usePoint = Number(document.getElementById("use-point").value);
  
  let regexp = new RegExp(/^[0-9]+$/);
  let isNumberFormat = regexp.test(document.getElementById("use-point").value);
  
  if (isNaN(usePoint) || (usePoint <= 0) || !Number.isInteger(usePoint) || !isNumberFormat) {
    disp.innerHTML = 'ポイントは半角数字で入力してください。';
    usePointObj.style.backgroundColor = errBackColor;
    return false;
  }

  let holdPointText = document.getElementById("cartPoints__info__header__pointCount__value").innerHTML.replaceAll(",","");
  let holdPoint = parseInt(holdPointText);
  
  if (holdPoint == 0) {
    disp.innerHTML = '利用できるポイントは0ポイントです。';
    usePointObj.style.backgroundColor = errBackColor;
    return false;
  }

  if (usePoint > 1000000) {
    disp.innerHTML = 'ポイント利用可能上限は1,000,000ポイントまでです。';
    usePointObj.style.backgroundColor = errBackColor;
    return false;
  }
  
  if (holdPoint < usePoint) {
    disp.innerHTML = '保有ポイントが不足しています。';
    usePointObj.style.backgroundColor = errBackColor;
    return false;
  }

  let customerId = document.getElementById('customerId').value;
  let subtotalPrice = getLocalStorage("sanyo_app_subtotal_price_" + customerId);
  if (subtotalPrice < usePoint) {
    disp.innerHTML = '購入金額以上のポイントはご利用になれません。';
    usePointObj.style.backgroundColor = errBackColor;
    return false;
  }

  return true;
}

/** ポイント利用API呼び出し */
async function usePointCallApi(point, url) {
  const params = {
    usePoint:  point
  };
  const query_params = new URLSearchParams(params);
  
  return await fetch(url + query_params , {
    method: 'POST'
  }).then(function(response) {
    if (response.status != 200) {
      console.log(response)
      throw new Error('status error');
    }
    return response.json();
  }).then(function(json) {
    if (!json.error_flg) {
      return json.giftCardCode;
    } else {
      if (json.error_msg) {
        dispMessage(json.error_msg);
      } else {
        throw new Error('application error');
      }
    }
  }).catch(function(err) {
    console.log(err)
    dispMessage('システムエラーが発生しました。\nページを再読み込みしてください。解決しない場合には、三陽商会ECカスタマーサポートへお問い合わせください。')
    throw new Error(err);
  });
}

/** ポイント利用キャンセルAPI呼び出し */
async function pointCancelCallApi(giftCard, url) {
  let customerId = document.getElementById('customerId').value;
  const params = {
    giftCardCode:  giftCard,
    usePoint: getLocalStorage("sanyo_app_use_point_" + customerId)
  };
  const query_params = new URLSearchParams(params);
  
  await fetch(url + query_params , {
    method: 'POST'
  }).then(function(response) {
    if (response.status != 200) {
      console.log(response)
      throw new Error('status error');
    }
    return response.json();
  }).then(function(json) {
    if (json.error_flg) {
      throw new Error('application error');
    }
  }).catch(function(response) {
    console.log(response)
    dispMessage('システムエラーが発生しました。\nページを再読み込みしてください。解決しない場合には、三陽商会ECカスタマーサポートへお問い合わせください。');
    throw new Error(err);
  });
}

/** ご購入時チェック */
function pointCheck() {
  let usePoint = document.getElementById("use-point").value;
  let disp = document.getElementById("err-disp");
  let usePointObj = document.getElementById("use-point");
  let errBackColor = "#ffb6c1";
  
  if (usePoint != 0) {
    disp.innerHTML = 
      '「ポイントを利用する」ボタンを押してください。<br>ポイントを利用しない場合、今回利用するポイント数に「0」をご入力ください。';
    usePointObj.style.backgroundColor = errBackColor;
    location.href= '#main-cart-footer';
    return false;
  }
  
  let customerId = document.getElementById('customerId').value;
  let usePointStorage = getLocalStorage("sanyo_app_use_point_" + customerId).replace(/,/g, "");
  let subtotalPrice = getLocalStorage("sanyo_app_subtotal_price_" + customerId);
  if (Number(usePointStorage) > subtotalPrice) {
    let usedDisp = document.getElementById("err-used-disp");
    usedDisp.innerHTML = '購入金額以上のポイントはご利用になれません。';
    location.href= '#main-cart-footer';
    return false;
  }

  return true;
}

/** localStorageから取得 */
function getLocalStorage(key) {
  return localStorage.getItem(key);
}

/** localStorageへ登録 */
function addLocalStorage(key, value) {
  localStorage.setItem(key, value);
}

/** localStorageから削除 */
function delLocalStorage(key) {
  localStorage.removeItem(key);
}
